import {getBlogInfo} from "@/api/bloginfo";

const state = {
  articleCount: 0,
  categoryCount:0,
  tagCount:0,
  viewsCount:0,
  pwdChrtype: '0',
  blogAvatar: '',
  blogIntro: '',
  blogAuthor: '',
  notice: ''
}
const mutations ={
  SET_ARTICLE_COUNT(state, articleCount){
    state.articleCount = articleCount;
  },
  SET_CATEGORY_COUNT(state, categoryCount){
    state.categoryCount = categoryCount;
  },
  SET_TAG_COUNT(state, tagCount){
    state.tagCount = tagCount;
  },
  SET_VIEWS_COUNT(state, viewsCount){
    state.viewsCount = viewsCount;
  },
  SET_PWD_CHRTYPE(state, pwdChrtype){
    state.pwdChrtype = pwdChrtype;
  },
  SET_BLOG_AVATAR(state, blogAvatar){
    state.blogAvatar = blogAvatar;
  },
  SET_BLOG_INTRO(state, blogIntro){
    state.blogIntro = blogIntro;
  },
  SET_BLOG_AUTHOR(state, blogAuthor){
    state.blogAuthor = blogAuthor;
  },
  SET_NOTICE(state, notice){
    state.notice = notice;
  }
}
const actions={
    // 获取博客信息
    BlogInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getBlogInfo().then(response => {
          const blogInfo = response.data;
          commit("SET_ARTICLE_COUNT", blogInfo.articleCount);
          commit("SET_CATEGORY_COUNT", blogInfo.categoryCount);
          commit("SET_TAG_COUNT", blogInfo.tagCount);
          commit("SET_VIEWS_COUNT", blogInfo.viewsCount);
          commit("SET_PWD_CHRTYPE", blogInfo.pwdChrtype);
          commit("SET_BLOG_AVATAR", process.env.VUE_APP_BASE_API+blogInfo.avatar);
          commit("SET_BLOG_INTRO", blogInfo.intro);
          commit("SET_BLOG_AUTHOR", blogInfo.nickname);
          commit("SET_NOTICE", blogInfo.notice);
          resolve(response);
        }).catch(error => {
          reject(error)
        })
      })
    },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
